import React from 'react';
import { Menu, MenuItem, Button, Popover, Position } from '@blueprintjs/core';
import { DateRangePicker } from '@blueprintjs/datetime';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import { FlexRow } from 'components/styled-components';
import Export from 'containers/Manage-Admin/audit-log/export';
import moment from 'moment';

const MenuRenderer = ({ items, handleClick, active }) => {
  return (
    <Menu>
      {items.map(item => (
        <MenuItem
          text={item.label}
          onClick={() => handleClick(item)}
          active={active.label === item.label}
          key={item.label}
        />
      ))}
      <MenuItem
        text="Custom Date Range"
        active={active.label === 'Custom Date Range'}
      >
        <DateRangePicker
          shortcuts={false}
          onChange={value => {
            handleClick({
              label: `${moment(value[0]).format('MM/DD/YYYY')} to${
                value[1] ? ` ${moment(value[1]).format('MM/DD/YYYY')}` : '...'
              }`,
              dateRange: value,
            });
          }}
          value={active.dateRange || [null, null]}
        />
      </MenuItem>
    </Menu>
  );
};

const Controls = ({ shortcutList, selectedValue, handleChangeDateRange }) => {
  return (
    <FlexRow padding="0 2rem 0.5rem">
      <Popover
        position={Position.BOTTOM}
        autoFocus={false}
        content={
          <MenuRenderer
            items={shortcutList}
            active={selectedValue}
            handleClick={handleChangeDateRange}
          />
        }
      >
        <Button
          text={selectedValue.label}
          icon={IconNames.CALENDAR}
          rightIcon={IconNames.CHEVRON_DOWN}
          minimal
          style={{
            padding: '5px 10px',
            border: `1px solid ${colors.lightGray}`,
            fontWeight: '700',
          }}
        />
      </Popover>
      <Export exportParams={selectedValue} />
    </FlexRow>
  );
};

export default Controls;
